<template>
  <div id="category" class="data-list-container vs-con-loading__container" v-if="config.order_feature == 1">
    <div class="vx-breadcrumb mb-6">
      <ul class="flex flex-wrap items-center">
          <li class="inline-flex items-end">
              <router-link to="/after-login">
                  <feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary" />
              </router-link>
              <span class="breadcrumb-separator mx-2 mr-1"><feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" /></span>
          </li>
          <li class="inline-flex items-end">
            <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">Category</span>
          </li>
      </ul>
    </div>

    <div class="w-full md:flex flex-wrap mb-base">
        <div class="flex justify-center md:w-1/2" v-for="(cate, index) in categoryList.items" :key="index"  @click="updateCate(cate)">
            <vx-card class="w-11/12 my-3 shadow-md">
                <div class="h-full flex justify-between align-center">
                    <div class="break-word">{{index + 1}}. {{cate.name}}</div>
                    <div class="flex-center" v-if="cate.id != 999999" style="min-width: 65px;">
                        <!-- <feather-icon icon="Edit2Icon" svgClasses="w-5 stroke-current ml-4 cursor-pointer icon-group" @click="popupUpdateActive = true"/> -->
                        <img src="../../assets/images/pen-icon.png" class="ml-5 pen-icon" @click="popupUpdateActive = true" />
                        <!-- <feather-icon icon="Trash2Icon" svgClasses="w-5 stroke-current ml-4 cursor-pointer icon-group" @click="popupDeleteActive = true"/> -->
                        <img src="../../assets/images/trash-icon.png" class="ml-5 trash-icon" @click="popupDeleteActive = true" />
                    </div>
                </div>
            </vx-card>
        </div>

        <div class="flex justify-center md:w-1/2">
            <vx-card class="w-11/12 my-3 plus-card cursor-pointer shadow-md" @click="popupAddActive = true">
              <div class="h-full flex justify-center align-center">
                  <!-- <feather-icon icon="PlusIcon" svgClasses="w-8 stroke-current ml-4 icon-plus"/> -->
                  <img src="../../assets/images/plus-icon.png" class="plus-icon" />
              </div>
            </vx-card>
            <vs-popup class="holamundo create-group create-popup" title="Create New Category" :active.sync="popupAddActive">
                <div>
                    <vs-input label="Name" v-validate="'required'" name="add_cate_name" v-model="add_cate_name" class="w-full" :danger="errors.has('add_cate_name')"
                    danger-text="The category name field is required" />
                    <div class="flex flex-wrap justify-center align-center p-6 mt-6">
                        <vs-button class="mr-6 align-center save-responsive" @click="saveAddCategory">Save</vs-button>
                        <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="closePopup">Cancel</vs-button>
                    </div>
                </div>
            </vs-popup>
        </div>
    </div>
    <!-- Update popup -->
    <vs-popup class="holamundo edit-group edit-popup" title="Edit Category" :active.sync="popupUpdateActive">
        <div>
            <vs-input label="Name" v-validate="'required'" name="cate_name" v-model="cate_name" class="w-full" :danger="errors.has('cate_name')"
            danger-text="The group name field is required"/>
            <div class="flex flex-wrap justify-center align-center p-6 mt-6">
                <vs-button class="mr-6 align-center save-responsive" @click="saveEditCate">Save</vs-button>
                <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="closePopup">Cancel</vs-button>
            </div>
        </div>
    </vs-popup>
    <!-- Delete popup -->
    <vs-popup class="holamundo delete-group delete-popup" title="Delete Category" :active.sync="popupDeleteActive">
        <div class="text-center">
            <h3>Do you want to delete this category?</h3>
            <div class="flex flex-wrap justify-center align-center p-6 mt-6">
            <vs-button class="mr-6 align-center delete-responsive" @click="deleteCate">Delete</vs-button>
            <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="closePopup">Cancel</vs-button>
            </div>
        </div>
    </vs-popup>
    <div v-if="categoryList._meta && categoryList._meta.pageCount">
        <custom-pagination class="custom-pagination mt-6" :totalPages="parseInt(categoryList._meta.pageCount)"
        :currentPage="currentPage" @pageChanged="changePage" :key="page_key"></custom-pagination>
    </div>
  </div>
  <div v-else-if="config.order_feature == 0"><vx-card><h2>This is for Go Check In full version, please contact us for more info at <b>832-968-6668</b></h2></vx-card></div>
  <custom-spinner v-else></custom-spinner>
</template>
<script>
export default {
  data(){
    return{
      popupAddActive: false,
      popupUpdateActive: false,
      popupDeleteActive: false,
      name: '',
      add_cate_name : '',
      action_type: '',
      isOpenLoading: false,
      check: true,
      id: 0,
      currentPage: 1,
      itemsPerPage: 8,
      page_key: 0
    }
  },
  methods:{
    updateCate(cate){
      this.name = cate.name;
      this.id = cate.id;
      this.cate = {
          id: this.id
      }
    },
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if(this.loadTime){
          clearTimeout(this.loadTime);
          this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
          if(this.isOpenLoading) {
              this.closeLoading();
              this.$vs.dialog({
                  color: 'danger',
                  title: 'Notification',
                  text: this.action_type + ' category failed',
                  acceptText: 'OK'
              })
          }
      }, 10000);
    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    changePage(currentPage) {
      this.openLoadingInDiv();
      const obj = {
          page: currentPage,
          "per-page": this.itemsPerPage,
      }

      this.action_type = "Get list";
      this.$store.dispatch("category/LIST_CATEGORY", obj).then(() => {
        this.closeLoading();
        this.currentPage = currentPage;
        this.page_key++;
      })
    },
    saveAddCategory(){
      if(this.add_cate_name != '') {
          const obj = {
              name: this.add_cate_name,
              page: this.currentPage,
              "per-page": this.itemsPerPage,
          }
          this.action_type = "Add";
          this.checkAlreadyName(this.add_cate_name)
          if(this.check == true){
            this.openLoadingInDiv();
            this.$store.dispatch('category/ADD_CATEGORY', obj).then(() => {
                this.closeLoading();
                this.closePopup();
                this.$vs.notify({
                    title:'Notification',
                    text:'Add Category Success',
                    color:'success',
                    position:'top-right'})
                this.add_cate_name = '';
            }).catch(() => {
                this.closeLoading();
                this.closePopup();
            })
          }else{
            this.closeLoading();
            this.check = true;
            this.$vs.notify({
              title:'Notification',
              text: this.add_cate_name + ' has already existed',
              color:'danger',
              position:'top-right'})
          }
      }
      this.$validator.validateAll();
    },
    saveEditCate(){
      if(this.name != '') {
        const obj = {
          id: this.id,
          name: this.name,
          page: this.currentPage,
          "per-page": this.itemsPerPage,
        }
        this.checkAlreadyName(this.name, this.id)
        this.action_type = "Update";
        if(this.check == true){
          this.openLoadingInDiv();
          this.$store.dispatch('category/UPDATE_CATEGORY', obj).then(() => {
              this.closeLoading();
              this.closePopup();
              this.$vs.notify({
                  title:'Notification',
                  text:'Update Category Name Success',
                  color:'success',
                  position:'top-right'})
          }).catch(() => {
              this.closeLoading();
              this.closePopup();
          })
        }else{
          this.closeLoading();
          // this.closePopup();
          this.check = true;
          this.$vs.notify({
            title:'Notification',
            text: this.name + ' has already existed',
            color:'danger',
            position:'top-right'})
            // this.name= '';
        }
      }
    },
    deleteCate(){
      const obj = {
          id: this.id,
          page: this.currentPage,
          "per-page": this.itemsPerPage,
      }
      this.action_type = "Delete";
      this.openLoadingInDiv();
      this.$store.dispatch('category/DELETE_CATEGORY', obj).then(() => {
          this.closeLoading();
          this.closePopup();
          this.$vs.notify({
              title:'Notification',
              text:'Delete Category Success',
              color:'danger',
              position:'top-right'})
      }).catch(() => {
          this.closeLoading();
          this.closePopup();
      })
    },
    closePopup() {
        this.popupUpdateActive = false;
        this.popupAddActive = false;
        this.popupDeleteActive = false;
    },
    checkAlreadyName(name, id){
      for(let i = 0; i< this.categoryList.items.length; i++){
        if(name.trim() == this.categoryList.items[i].name.trim() && id != this.categoryList.items[i].id){
          this.check = false;
        }
      }
    },
  },
  computed:{
    categoryList() {
      return this.$store.state.category.categoryList;
    },
    cate_name: {
      get() {
          return this.name;
      },
      set(value) {
          this.name = value;
      }
    },
    config() {
      return this.$store.getters["auth/config"];
    },
  },
  watch: {
    // config: {
    //   immediate: true,
    //   deep: true,
    //   handler() {
    //     if(this.config && this.config.order_feature != 0 && this.config.order_feature != 1) {
    //       this.action_type = "Get data";
    //       this.openLoadingInDiv();
    //     } else {
    //       this.closeLoading();
    //     }
    //   }
    // },
    popupAddActive: {
      immediate: true,
      deep: true,
      handler() {
        this.errors.clear();
      }
    },
    popupUpdateActive: {
      immediate: true,
      deep: true,
      handler() {
        this.errors.clear();
      }
    }
  },
  created(){
    let obj = {
      page: this.currentPage,
      'per-page': this.itemsPerPage
    }
    this.$store.dispatch("category/LIST_CATEGORY", obj);
  }
}
</script>
